import Parse from "parse";
import { filterKeys, getClassName } from "./ParseConfiguration";
import { Speaker, SpeakerModel } from "../Models/Speaker.ts";
import { addImageIfExists } from "./ParseConfiguration";
import { handleError } from "./ErrorHandler.ts";
import { setLimit } from "./ParseConfiguration";


const SPEAKERS_TABLE: any = getClassName("Speaker")


export async function getSpeakers(): Promise<SpeakerModel[]> {
  try {
    const query = new Parse.Query(SPEAKERS_TABLE)
    query.descending("createdAt")
    const count = await query.count()
    setLimit(query, count)
    const result = await query.find()

    return result.map((parseObject: any) =>
      Speaker.convertFromParseObject(parseObject)
    )
  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function getSpeakerById(objectId: string): Promise<SpeakerModel> {
  try {
    const query = new Parse.Query(SPEAKERS_TABLE)
    const parseObject = await query.get(objectId)
    const result = Speaker.convertFromParseObject(parseObject)
    return result

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function addOrUpdateSpeaker(newSpeaker: SpeakerModel, avatar: string): Promise<void> {
  try {
    const Speaker = SPEAKERS_TABLE
    const speaker = new Speaker()
    Object.entries(newSpeaker)
      .filter((key) => !filterKeys.includes(key[0]))
      .forEach((key) => {
        speaker.set(key[0], key[1])
      })
    await addImageIfExists(speaker, avatar, "avatar")
    await speaker.save()

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function deleteSpeaker(objectId: string): Promise<void> {
  try {
    const query = new Parse.Query(SPEAKERS_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      await result[0].destroy()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}
